export default __webpack_public_path__ + "static/media/05.f64cfc28.jpg";